/* eslint-disable @typescript-eslint/ban-types */
import * as features from './features';
import { marketingPageSections as ms } from './sections';
import { loadOnDemand } from '~utils/loadOnDemand';
import {
    ILoyaltyMarketingPage,
    LoyaltyMarketingConfig
} from '~exported/loyalty-marketing-page/ILoyaltyMarketingPage';
import LoyaltyMarketingPageController from '~exported/loyalty-marketing-page/LoyaltyMarketingPageController';

export interface IMarketingPageFeature {
    controller: ILoyaltyMarketingPage['viewController'];
    componentConfig?: LoyaltyMarketingConfig
    children?: JSX.Element | JSX.Element[];
}

export function loadFeatureOnDemand(
    feature: Function,
    componentConfig: LoyaltyMarketingConfig | undefined,
    controller: LoyaltyMarketingPageController,
    paramsKey: string
) {
    const params = componentConfig?.[paramsKey]?.params || {};
    const config = componentConfig?.[paramsKey] || {};

    return loadOnDemand(feature, { ...params, viewController: controller, ...config });
}

export const getMarketingPageViewRegistry = (featureConfig: IMarketingPageFeature) => {
    const { componentConfig, controller } = featureConfig;

    return {
        [ms.heroSection]: loadOnDemand(
            features.HeroSection,
            componentConfig?.[ms.heroSection]?.params
        ),
        [ms.dynamicRedirection]: loadFeatureOnDemand(
            features.DynamicRedirection,
            componentConfig,
            controller,
            ms.dynamicRedirection
        ),
        [ms.dynamicRedirectionBanner]: loadFeatureOnDemand(
            features.DynamicRedirection,
            componentConfig,
            controller,
            ms.dynamicRedirectionBanner
        ),
        [ms.dynamicRedirectionFooter]: loadFeatureOnDemand(
            features.DynamicRedirection,
            componentConfig,
            controller,
            ms.dynamicRedirectionFooter
        ),
        [ms.pointBenefit]: loadOnDemand(
            features.PointBenefit,
            componentConfig?.[ms.pointBenefit]?.params
        ),
        [ms.benefitsRewards]: loadFeatureOnDemand(
            features.BenefitsRewards,
            componentConfig,
            controller,
            ms.benefitsRewards
        ),
        [ms.howItWorks]: loadOnDemand(
            features.HowItWorks,
            componentConfig?.[ms.howItWorks]?.params
        ),
        [ms.tierBenefits]: loadOnDemand(
            features.TierBenefits,
            componentConfig?.[ms.tierBenefits]?.params
        ),
        [ms.earnPoints]: loadOnDemand(
            features.LoyaltyEarnPoints,
            componentConfig?.earnPoints?.params
        )
    };
};
